function initDelayedTemplates() {
  const templates = document.querySelectorAll('template.delay-load');

  templates.forEach((tpl) => {
    const parentClass = tpl.dataset.parent;
    const templateParent = document.querySelector(`.${parentClass}`);

    templateParent.appendChild(tpl.content.cloneNode(true));
    tpl.remove();
  });

  if (typeof initScrollers === 'function') { initScrollers(); }
  if (typeof detectScrollContainerOverflow === 'function') { detectScrollContainerOverflow(); }
  if (typeof initiSlideShow === 'function') { initiSlideShow(); }
  if (typeof initFeaturedCollection === 'function') { initFeaturedCollection(); }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDelayedTemplates);
} else {
  initDelayedTemplates();
}

window.addEventListener('resize', () => {
  detectScrollContainerOverflow();

  document.querySelectorAll('.scroller-wrapper').forEach(sw => {
    setupScrollDots(sw);
    updateScrollButtons(sw);
    updateActiveDot(sw);
  });
});

document.addEventListener('shopify:section:load', () => {
  initScrollers();
  detectScrollContainerOverflow();

  document.querySelectorAll('.scroller-wrapper').forEach(sw => {
    setupScrollDots(sw);
  });
});


/**
 * lazy-loading behaviour for sections.
 */
const lazySections = document.querySelectorAll('.lazy-section');
const rrObserver = new IntersectionObserver((entries, obs) => {
  
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;

    const target = entry.target;
    const tpl = target.querySelector('template.lazy-load');

    if (tpl) {
      target.appendChild(tpl.content.cloneNode(true));
      tpl.remove();
      
      if (typeof initMiniCompare === 'function') { initMiniCompare(); }
      if (typeof initReviews === 'function') { initReviews(); }
    }
    setTimeout(() => {
      target.classList.add('section-visible');
    }, 500);

    obs.unobserve(target);
  });

}, {
  root: null,
  rootMargin: '100px',
  threshold: 0.1
});

lazySections.forEach(section => rrObserver.observe(section));

/** Card-aligned targets, with the final target clamped to show the last card. */
function getCardScrollTargets(sw) {
  const container = sw.querySelector('.scroll-container');
  const cards = sw.querySelectorAll('.product-ul > li');
  const max = Math.max(0, container.scrollWidth - container.clientWidth);
  const targets = [0];
  const origin = cards.length ? cards[0].getBoundingClientRect().left : 0;

  cards.forEach(card => {
    const target = Math.min(max, Math.max(0, card.getBoundingClientRect().left - origin));
    if (target - targets[targets.length - 1] > 1) targets.push(target);
  });
  if (max - targets[targets.length - 1] > 1) targets.push(max);
  return targets;
}

/**
 * Updates the left and right scroll button active states
 * based on the current scroll position of the container.
 */
function updateScrollButtons(sw) {
  const leftBtn = sw.querySelector('.scroll-button.left');
  const rightBtn = sw.querySelector('.scroll-button.right');
  const scrollContainer = sw.querySelector('.scroll-container');

  if (!scrollContainer || !leftBtn || !rightBtn) return;

  const scrollLeft = scrollContainer.scrollLeft;
  const clientWidth = scrollContainer.clientWidth;
  const scrollWidth = scrollContainer.scrollWidth;

  const atStart = scrollLeft <= 1;
  const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

  if (sw.hasAttribute('data-scroll-by-card')) {
    leftBtn.disabled = atStart;
    rightBtn.disabled = atEnd;
  }

  leftBtn.classList.toggle('active', !atStart);
  rightBtn.classList.toggle('active', !atEnd);
}

/**
 * Checks each scroller wrapper for horizontal overflow,
 * toggles overflow classes, clears dots when not needed,
 * and refreshes buttons and dots when scrolling is available.
 */
function detectScrollContainerOverflow() {
  document.querySelectorAll('.scroller-wrapper').forEach(sw => {
    const leftBtn = sw.querySelector('.scroll-button.left');
    const rightBtn = sw.querySelector('.scroll-button.right');
    const scrollContainer = sw.querySelector('.scroll-container');
    const dotsContainer = sw.querySelector('.scroll-dots');

    if (!scrollContainer || !leftBtn || !rightBtn) return;

    const hasOverflow = scrollContainer.scrollWidth > scrollContainer.clientWidth;

    sw.classList.toggle('has-overflow', hasOverflow);
    sw.classList.toggle('no-overflow', !hasOverflow);

    if (!hasOverflow) {
      leftBtn.classList.remove('active');
      rightBtn.classList.remove('active');

      if (dotsContainer) {
        dotsContainer.innerHTML = '';
      }
    } else {
      updateScrollButtons(sw);
      setupScrollDots(sw);
    }
  });
}

/**
 * Finds all scroller wrappers and initializes them once by:
 * - attaching click handlers to scroll buttons
 * - attaching scroll listeners to the container
 * - setting up dots and initial button/dot states
 */
function initScrollers() {
  const scrollers = document.querySelectorAll('.scroller-wrapper');

  scrollers.forEach(sw => {
    if (sw.classList.contains('scroller-initialized')) return;

    const btns = sw.querySelectorAll('.scroll-button');
    const scrollContainer = sw.querySelector('.scroll-container');

    if (!scrollContainer || !btns.length) return;

    sw.classList.add('scroller-initialized');

    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (sw.hasAttribute('data-scroll-by-card')) {
          if (btn.disabled) return;
          const targets = getCardScrollTargets(sw);
          const current = scrollContainer.scrollLeft;
          const target = btn.classList.contains('right')
            ? targets.find(value => value > current + 1)
            : targets.slice().reverse().find(value => value < current - 1);
          if (target !== undefined) {
            scrollContainer.scrollTo({ left: target, behavior: 'smooth' });
          }
          return;
        }
        const visibleWidth = scrollContainer.clientWidth;
        const scrollAmount = visibleWidth - 80;
        const direction = btn.classList.contains('right') ? scrollAmount : -scrollAmount;

        scrollContainer.scrollBy({
          left: direction,
          behavior: 'smooth'
        });
      });
    });

    scrollContainer.addEventListener('scroll', () => {
      updateScrollButtons(sw);
      updateActiveDot(sw);
    });

    setupScrollDots(sw);
    updateScrollButtons(sw);
    updateActiveDot(sw);
  });
}

/**
 * Builds the correct number of pagination dots for a scroller
 * based on the visible width and total scrollable width,
 * and attaches click handlers to jump between scroll positions.
 */
function setupScrollDots(sw) {
  const scrollContainer = sw.querySelector('.scroll-container');
  const dotsContainer = sw.querySelector('.scroll-dots');

  if (!scrollContainer || !dotsContainer) return;

  dotsContainer.innerHTML = '';

  const visibleWidth = scrollContainer.clientWidth;
  const totalWidth = scrollContainer.scrollWidth;
  const step = visibleWidth - 80;

  if (step <= 0 || totalWidth <= visibleWidth) return;

  const targets = sw.hasAttribute('data-scroll-by-card') ? getCardScrollTargets(sw) : null;
  const pageCount = targets ? targets.length : Math.ceil((totalWidth - visibleWidth) / step) + 1;

  for (let i = 0; i < pageCount; i++) {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.classList.add('scroll-dot');
    dot.setAttribute('aria-label', `Go to slide ${i + 1}`);

    dot.addEventListener('click', () => {
      scrollContainer.scrollTo({
        left: targets ? targets[i] : i * step,
        behavior: 'smooth'
      });
    });

    dotsContainer.appendChild(dot);
  }

  updateActiveDot(sw);
}

/**
 * Updates the active pagination dot by calculating
 * which scroll "page" is currently closest to the
 * container's current scroll position.
 */
function updateActiveDot(sw) {
  const scrollContainer = sw.querySelector('.scroll-container');
  const dots = sw.querySelectorAll('.scroll-dot');

  if (!scrollContainer || !dots.length) return;

  const visibleWidth = scrollContainer.clientWidth;
  const step = visibleWidth - 80;
  const scrollLeft = scrollContainer.scrollLeft;

  const targets = sw.hasAttribute('data-scroll-by-card') ? getCardScrollTargets(sw) : null;
  const index = targets
    ? targets.reduce((closest, target, i) =>
        Math.abs(target - scrollLeft) < Math.abs(targets[closest] - scrollLeft) ? i : closest, 0)
    : Math.round(scrollLeft / step);

  dots.forEach((dot, i) => {
    dot.classList.toggle('active', i === index);
  });
}

/*
  Adds countdown timer functionality to any element with the class 'rr-countdown-timer'
  Follow structure of UK-Theme/snippets/pdp-promo-banner-v3.liquid
*/
const timerContainers = document.querySelectorAll('.rr-countdown-timer');

if (timerContainers) {
  timerContainers.forEach(timer => {
    const daysEl = timer.querySelector('[data-countdown-days]');
    const hoursEl = timer.querySelector('[data-countdown-hours]');
    const minutesEl = timer.querySelector('[data-countdown-minutes]');
    const secondsEl = timer.querySelector('[data-countdown-seconds]');

    let totalSeconds =
      Number(timer.dataset.days) * 86400 +
      Number(timer.dataset.hours) * 3600 +
      Number(timer.dataset.minutes) * 60 +
      Number(timer.dataset.seconds);

    function updateCountdown() {
      if (totalSeconds <= 0) {
        totalSeconds = 0;
      }

      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      daysEl.textContent = days;
      hoursEl.textContent = hours;
      minutesEl.textContent = minutes;
      secondsEl.textContent = seconds;

      if (totalSeconds > 0) {
        totalSeconds--;
      }
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
}
 
// Cloudflare Input data recording
const API_BASE = 'https://input-search-worker.matt-robinson-0dd.workers.dev';

let lastSearch = null;

async function recordSearch(searchBtn) {
  const inputSelector = document.querySelector(
    `.${searchBtn.dataset.searchInput}`
  );

  if (!inputSelector) return;

  const payload = {
    url: window.location.href,
    inputName: inputSelector.name || 'unknown_input',
    inputValue: inputSelector.value || 'empty',
    resultsCount: window.rrSparesVisibleCount || 0
  };

  // Stop duplicate searches
  if (
    lastSearch &&
    JSON.stringify(payload) === JSON.stringify(lastSearch)
  ) {
    return;
  }

  // Store a copy of the payload
  lastSearch = { ...payload };

  try {
    const response = await fetch(API_BASE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();

    console.log('Search recorded:', data);
  } catch (error) {
    console.error('Failed to record search:', error);
  }
}

// Listen for clicks on the search submit buttons
document.addEventListener('click', (e) => {
	const searchBtn = e.target.closest('[data-submit-search="submit-record"]');
	const guaranteeTab = e.target.closest('.guarantee-tab');
  const payLaterTab = e.target.closest('.pay-later-tab');
  const modalLink = e.target.closest('.mr-custom-modalLink');
  const collectionCompareSection = document.querySelector(`.${e.target.getAttribute('data-compare-section')}`);

	if (searchBtn) { recordSearch(searchBtn); }
	if (guaranteeTab) { updateGuaranteeTab(guaranteeTab); }
	if (payLaterTab) { updatePayLaterTab(payLaterTab); }
  if (modalLink) { openModalById(modalLink, e); }
  if (collectionCompareSection) { openCompareOnCollection(collectionCompareSection); }
});

//listens for enter key presses on search inputs
document.addEventListener('keydown', function (event) {
  if (event.key === 'Enter' && document.activeElement.classList.contains('record-input')) {

    const input = document.activeElement;
    if (input.classList.contains('record-input')) {
      const correspondingSearchButton = document.querySelector(`.${input.dataset.searchCorrespondingButton}`);

      event.preventDefault();
      correspondingSearchButton.click();
    }
  }
});